module.exports = __webpack_public_path__ + "static/img/service_h5_03_zh.4cae0b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_h5_03_zh.png
// module id = cfTG
// module chunks = 34